class ShippingCalculator {
  constructor(container) {
    this.container = container;
    this.form = container.querySelector('form');
    this.resultsContainer = container.querySelector('.shipping-calculator__results');
    this.ratesList = container.querySelector('[id*="shipping-rates-list"]');
    this.errorContainer = container.querySelector('.shipping-calculator__error');
    
    if (this.form) {
      this.init();
    }
  }

  init() {
    this.form.addEventListener('submit', (e) => this.handleSubmit(e));
    
    const formFields = this.form.querySelectorAll('input, select');
    formFields.forEach(field => {
      field.addEventListener('change', (e) => e.stopPropagation());
      field.addEventListener('input', (e) => e.stopPropagation());
    });
  }

  async handleSubmit(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const country = this.form.querySelector('[name="country"]').value;
    const province = this.form.querySelector('[name="province"]').value;
    const zip = this.form.querySelector('[name="zip"]').value;

    if (!country || !zip) {
      this.showError('Please complete all required fields');
      return;
    }

    this.hideError();
    this.showLoading();

    try {
      const rates = await this.fetchShippingRates(country, province, zip);
      this.displayRates(rates);
    } catch (error) {
      this.showError(error.message);
    }
  }

  async fetchShippingRates(country, province, zip) {
    const prepareUrl = '/cart/prepare_shipping_rates.json';
    const prepareData = {
      shipping_address: {
        zip: zip,
        country: country,
        province: province
      }
    };

    try {
      const prepareResponse = await fetch(prepareUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(prepareData)
      });

      if (!prepareResponse.ok) {
        throw new Error('Unable to prepare shipping calculation');
      }

      await this.sleep(1500);

      const ratesUrl = `/cart/shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`;
      
      const ratesResponse = await fetch(ratesUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!ratesResponse.ok) {
        throw new Error('Unable to retrieve shipping rates');
      }

      const data = await ratesResponse.json();
      
      if (!data.shipping_rates || data.shipping_rates.length === 0) {
        throw new Error('No shipping methods available for this address');
      }

      return data.shipping_rates;
    } catch (error) {
      console.error('Error fetching shipping rates:', error);
      throw error;
    }
  }

  displayRates(rates) {
    this.ratesList.innerHTML = '';
    
    rates.forEach(rate => {
      const rateElement = document.createElement('div');
      rateElement.className = 'shipping-rate';
      
      const price = rate.price === '0.00' 
        ? 'Free' 
        : this.formatMoney(rate.price);
      
      rateElement.innerHTML = `
        <div class="shipping-rate__info">
          <span class="shipping-rate__name">${rate.name}</span>
          <span class="shipping-rate__price">${price}</span>
        </div>
        ${rate.delivery_range ? `
          <div class="shipping-rate__delivery">
            Delivery: ${rate.delivery_range[0]} - ${rate.delivery_range[1]} days
          </div>
        ` : ''}
      `;
      
      this.ratesList.appendChild(rateElement);
    });

    this.resultsContainer.style.display = 'block';
  }

  formatMoney(cents) {
    const amount = parseFloat(cents);
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: Shopify.currency.active || 'EUR'
    }).format(amount);
  }

  showLoading() {
    this.ratesList.innerHTML = '<div class="loading">Calculating shipping...</div>';
    this.resultsContainer.style.display = 'block';
  }

  showError(message) {
    this.errorContainer.textContent = message;
    this.errorContainer.style.display = 'block';
    this.resultsContainer.style.display = 'none';
  }

  hideError() {
    this.errorContainer.style.display = 'none';
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}

// Inicializar todos los calculadores en la página
function initAllShippingCalculators() {
  const calculators = document.querySelectorAll('.shipping-calculator');
  calculators.forEach(calc => {
    if (!calc.dataset.initialized) {
      new ShippingCalculator(calc);
      calc.dataset.initialized = 'true';
    }
  });
}

// Inicialización inicial
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllShippingCalculators);
} else {
  initAllShippingCalculators();
}

// Reinicializar cuando cambie el DOM (para el drawer)
const observer = new MutationObserver(() => {
  initAllShippingCalculators();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});